export const messages = {
  en: {
    scheduleClassesStaffManage: {
      title: 'Shift Staff Management',
      staffId: 'Staff ID',
      staffName: 'Staff Name',
      createTime: 'Create Time',
      addTitle: 'Add Shift Staff',
      selectStaffWarning: 'Please select at least one staff',
      confirmDeleteStaff: 'Are you sure to delete this shift staff?',
      orgInfo: 'Organization Info',
      staffInfo: 'Staff Info',
      selectedStaff: 'Selected Staff',
      staffExists: 'Staff already selected'
    }
  },
  zh: {
    scheduleClassesStaffManage: {
      title: '班次员工管理',
      staffId: '员工ID',
      staffName: '员工名称',
      createTime: '创建时间',
      addTitle: '添加班次员工',
      selectStaffWarning: '请至少选择一名员工',
      confirmDeleteStaff: '确定要删除该班次员工吗？',
      orgInfo: '组织信息',
      staffInfo: '员工信息',
      selectedStaff: '已选员工',
      staffExists: '员工已选择'
    }
  }
}